import Logger from '../lib/logger';

export default class ProfessionalMediaTextSoftwareModal {
	constructor(dom) {
		this.NAME = 'ProfessionalMediaTextSoftwareModal';
		this.dom = dom;
		this.configs = dom.querySelectorAll(
			'[data-professional-media-text-software-modal-config]'
		);
		this.modal = dom.querySelector(
			'[data-professional-media-text-software-modal]'
		);
		this.backdrop = dom.querySelector(
			'[data-professional-media-text-software-modal-backdrop]'
		);
		this.closeBtn = dom.querySelector(
			'[data-professional-media-text-software-modal-close]'
		);
		this.iframe = dom.querySelector(
			'[data-professional-media-text-software-modal-iframe]'
		);
		this.onEscBound = this.onEsc.bind(this);
		this.onHashChangeBound = this.onHashChange.bind(this);
		this.scrollY = 0;
		this.activeModalId = null;
	}

	init() {
		Logger.info(`${this.NAME} > init`);

		if (!this.configs.length || !this.modal || !this.iframe) return;

		this.closeBtn?.addEventListener('click', (event) => {
			event.preventDefault();
			this.close(true);
		});

		this.backdrop?.addEventListener('click', () => {
			this.close(true);
		});

		window.addEventListener('hashchange', this.onHashChangeBound);
		this.onHashChange();
	}

	onHashChange() {
		let modalId = window.location.hash.replace(/^#/, '');

		try {
			modalId = decodeURIComponent(modalId);
		} catch (error) {
			return;
		}

		const config = Array.from(this.configs).find(
			(item) => item.getAttribute('data-modal-id') === modalId
		);

		if (!config) {
			if (this.activeModalId) this.close(true, false);
			return;
		}

		const iframeUrl = config.getAttribute('data-iframe-url');
		if (!iframeUrl) return;

		this.open(
			modalId,
			iframeUrl,
			config.getAttribute('data-iframe-title') || 'Software'
		);
	}

	open(modalId, iframeUrl, iframeTitle) {
		if (
			this.activeModalId === modalId &&
			!this.modal.hasAttribute('hidden')
		) {
			return;
		}

		const isOpen = !this.modal.hasAttribute('hidden');
		this.activeModalId = modalId;
		this.iframe.setAttribute('title', iframeTitle);
		this.iframe.src = iframeUrl;

		if (!isOpen) {
			this.scrollY = window.scrollY;
			document.body.style.top = `-${this.scrollY}px`;
			document.body.style.paddingRight = '15px';
			document.body.style.position = 'fixed';
			document.body.style.width = '100%';
			document.body.style.zIndex = '0';
		}

		this.modal.removeAttribute('hidden');
		this.modal.setAttribute('aria-hidden', 'false');
		document.addEventListener('keydown', this.onEscBound);
		this.closeBtn?.focus();
	}

	close(instant, clearHash = true) {
		if (this.modal.hasAttribute('hidden')) return;

		const activeModalId = this.activeModalId;
		this.activeModalId = null;
		this.modal.setAttribute('hidden', '');
		this.modal.setAttribute('aria-hidden', 'true');
		this.iframe.src = '';

		document.body.style.paddingRight = '';
		document.body.style.position = '';
		document.body.style.width = '';
		document.body.style.top = '';
		document.body.style.zIndex = '';

		const y = this.scrollY;
		document.removeEventListener('keydown', this.onEscBound);

		if (instant && typeof window.scrollTo === 'function') {
			window.scrollTo({ top: y, behavior: 'instant' });
		} else {
			window.scrollTo(0, y);
		}

		if (
			clearHash &&
			activeModalId &&
			window.location.hash === `#${activeModalId}`
		) {
			history.replaceState(
				null,
				document.title,
				`${window.location.pathname}${window.location.search}`
			);
		}
	}

	onEsc(event) {
		if (event.key === 'Escape') this.close(true);
	}
}
